// Roteamento único por tipo (contrato P0). Cruzadas usam o id do passatempo;
// rébus, quiz, caça-palavras e sudoku usam o id do jogo.
export type GameSlug = 'palavrascruzadas' | 'rebus' | 'quiz' | 'cacapalavras' | 'sudoku';

const CROSSWORD_TIPOS = [1, 2, 3, 4, 9];

const SLUG_BY_TIPO: Record<number, GameSlug> = {
  5: 'rebus',
  6: 'quiz',
  7: 'cacapalavras',
  8: 'sudoku',
};

export function gameSlugForTipo(tipo: number | null | undefined): GameSlug | null {
  if (tipo === null || tipo === undefined) return 'palavrascruzadas';
  if (CROSSWORD_TIPOS.includes(tipo)) return 'palavrascruzadas';
  return SLUG_BY_TIPO[tipo] ?? null;
}

export function gameRoute(tipo: number | null | undefined, id: number): string | null {
  const slug = gameSlugForTipo(tipo);
  if (!slug || !Number.isInteger(id) || id <= 0) return null;
  return `/jogo/${slug}/${id}`;
}
